export const contentImagesRelativePath = '../../../../';


// WEBPACK FOOTER //
// ./src/constants.ts